<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'BaseCircleProgressBar',
    props: {
      progressBarTime: {
        type: Number,
        default: 0,
        required: true,
      },
      progressBarColor: {
        type: String,
        default: '#3b889f',
      },
      progressBarBgColor: {
        type: String,
        default: '#FFFFFF',
      },
      withTime: {
        type: Boolean,
        default: false,
      },
      progressBarWidth: {
        type: Number,
        default: 3,
      },
      width: {
        type: Number,
        default: 30,
      },
    },
    emits: ['timerEnd'],
    data() {
      return {
        progressValue: 0,
      }
    },
    computed: {
      conicGradient() {
        return `conic-gradient(${this.progressBarColor} 0%, ${this.progressBarColor} ${this.getPercent}%, transparent ${this.getPercent}%)`
      },
      getPercent() {
        return (this.progressValue / this.progressBarTime) * 100
      },
    },
    mounted() {
      this.setProgressBar()
    },
    methods: {
      setProgressBar() {
        this.progressValue = 0
        const progressEndValue = this.progressBarTime
        let progress = setInterval(() => {
          this.progressValue++
          if (this.progressValue === progressEndValue) {
            clearInterval(progress)
            this.$emit('timerEnd')
          }
        }, progressEndValue)
      },
    },
  })
</script>

<template>
  <div
    class="circle-progress-bar"
    :style="{
      background: conicGradient,
      width: width + 'px',
      height: width + 'px',
    }"
  >
    <div
      class="circle-progress-bar-content"
      :style="{
        background: progressBarBgColor,
        width: width - progressBarWidth + 'px',
        height: width - progressBarWidth + 'px',
      }"
    >
      <div v-if="withTime">
        {{ ((progressBarTime - progressValue) / 10).toFixed() }}
      </div>
      <slot v-else></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .circle-progress-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    &-content {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
    }
  }
</style>
